import { render, staticRenderFns } from "./PageLoading.vue?vue&type=template&id=315d86fe&scoped=true&lang=pug"
import script from "./PageLoading.vue?vue&type=script&lang=ts"
export * from "./PageLoading.vue?vue&type=script&lang=ts"
import style0 from "./PageLoading.vue?vue&type=style&index=0&id=315d86fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315d86fe",
  null
  
)

export default component.exports